import ErrorReporter, { defaultTransformer } from "@bookingcom/error-reporter";
export function transformErrorToJSError(error) {
    return {
        name: "js_errors",
        file: error.be_file,
        message: error.be_message,
        column: error.be_column,
        line: error.be_line,
        ref_action: error.ref_action,
        pid: error.pid,
        url: error.url,
        stack: error.be_stack
    };
}
export function flightsClientsideErrorReporter(action, pageViewId, experimentContext) {
    const headersParams = {};
    if (experimentContext) {
        headersParams["X-Booking-Experiment-State-Blob"] = experimentContext;
    }
    return new ErrorReporter({
        payloadContentType: "application/json",
        requestHeaders: headersParams,
        handleWindowErrors: false,
        transform: (error) => transformErrorToJSError(defaultTransformer(error, action, pageViewId))
    });
}
export default function reportError(error, action, pageViewId, experimentContext) {
    if (error && error.message) {
        const reporter = flightsClientsideErrorReporter(action, pageViewId, experimentContext);
        reporter.sendError(error);
    }
}
export class FlightsErrorReporter {
    static flightsErrorReporter;
    errorReporter;
    action;
    pageViewId;
    errorSeenSoFar = 0;
    constructor() {
        this.errorReporter = new ErrorReporter({
            payloadContentType: "application/json",
            handleWindowErrors: true,
            maxErrorsToReport: 20,
            transform: (error) => this.flightsJSErrorsTransformer(error)
        });
    }
    static getInstance() {
        if (!FlightsErrorReporter.flightsErrorReporter) {
            FlightsErrorReporter.flightsErrorReporter = new FlightsErrorReporter();
        }
        return FlightsErrorReporter.flightsErrorReporter;
    }
    resetErrorReporter(action, pageViewId, experimentContext) {
        this.action = action;
        this.pageViewId = pageViewId;
        this.errorSeenSoFar = 0;
        this.errorReporter.setErrorsReportedSoFar = 0;
        this.errorReporter.setRequestHeaders = { "X-Booking-Experiment-State-Blob": experimentContext || "" };
    }
    sendError(error) {
        if (error && error.message) {
            this.errorSeenSoFar = this.errorSeenSoFar + 1;
            this.errorReporter.sendError(error);
        }
    }
    flightsJSErrorsTransformer(error) {
        return {
            name: "js_errors",
            file: error.url || document.location.href,
            message: error.message || "",
            column: error.colno || 0,
            line: error.lno || 0,
            ref_action: this.action,
            pid: this.pageViewId || 1,
            url: error.url,
            stack: error.stack || "",
            errc: this.errorSeenSoFar,
            errp: this.errorSeenSoFar - 1
        };
    }
}
